import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CreateAccountComponent } from "./components/create-account/create-account.component";
import { ReactiveFormsModule } from "@angular/forms";
import { UiCoreModule } from "@logex/framework/ui-core";
import { UiToolboxModule } from "@logex/framework/ui-toolbox";
import { LgLocalizationModule } from "@logex/framework/lg-localization";
import { LanguageSwitchComponent } from "./components/language-switch/language-switch.component";
import { AccountButtonComponent } from "./components/account-button/account-button.component";

@NgModule({
    declarations: [CreateAccountComponent, LanguageSwitchComponent, AccountButtonComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,

        UiCoreModule,
        UiToolboxModule,
        LgLocalizationModule
    ],
    exports: [CreateAccountComponent, LanguageSwitchComponent, AccountButtonComponent]
})
export class SharedModule {}
